import { Brain, ArrowRight } from "lucide-react";

export default function WeakReviewView({ review, onStartMiniQuiz }) {
  return (
    <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-8 sm:py-12 ss-fadein" data-testid="weak-review-view">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">
        <Brain className="w-3.5 h-3.5" /> Powtórka słabych obszarów
      </div>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
        Skupmy się na tym, co nie poszło
      </h1>
      <p className="mt-3 text-slate-600">Krótkie wyjaśnienia tylko tych zagadnień, w których się pomyliłeś. Potem 5 nowych pytań.</p>

      <div className="mt-6 space-y-4">
        {review.focused_explanations?.map((f, i) => (
          <div key={i} className="bg-[#FEF9C3] border border-yellow-200 rounded-2xl p-5" data-testid={`focused-explanation-${i}`}>
            <div className="text-xs font-bold uppercase tracking-wider text-slate-600 mb-1">{f.topic_area}</div>
            <p className="text-slate-900 leading-relaxed">{f.explanation}</p>
          </div>
        ))}
      </div>

      <div className="mt-10">
        <button
          onClick={onStartMiniQuiz}
          data-testid="start-mini-quiz-button"
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#FFD600] hover:bg-[#E6C200] text-slate-900 font-bold text-lg px-8 py-4 rounded-2xl btn-yellow-glow"
        >
          Rozwiąż 5 nowych pytań
          <ArrowRight className="w-5 h-5" strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}
